import { Component, EventEmitter, OnChanges, Output, Input, OnInit, OnDestroy } from '@angular/core';
import { IBreadcrumbItem } from "libraries/service/breadcrumb/IBreadcrumbItem";
import { Yii } from "libraries/interfaces/Yii";
import { BtnStyleTypes } from "libraries/ui_button/btn.component";
import { ILabels } from "libraries/interfaces/ILabels";
import { QuotationBreadcrumbService } from "./quotation-breadcrumb.service";
import { EQuotationEntryPoints } from "libraries/enums/e-quotation-entry-points";

@Component({
    selector: 'quotation-breadcrumb',
    template: `
        <breadcrumb [items]="items" (notify)="notify($event)">
            <div class="additional-content">
                <btn [type]="btnType.actionLink" [value]="wording.close" (onClick)="close()" *ngIf="showCloseButton"></btn>
                <btn [type]="btnType.actionDo" [value]="wording.next"></btn>
            </div>
        </breadcrumb>`,
    styles: [ `
        .additional-content btn:not(:last-of-type) {
            margin-right: .75rem;
        }

        :host {
            font-size: 1rem;
        }
    ` ],
})
export class QuotationBreadcrumbComponent {

    @Output()
    public readonly onClose: EventEmitter<null> = new EventEmitter();
    @Output()
    public readonly onNext: EventEmitter<null> = new EventEmitter();
    @Output()
    public readonly onNotify: EventEmitter<EQuotationEntryPoints> = new EventEmitter<EQuotationEntryPoints>();

    @Input()
    public showCloseButton: boolean;

    public btnType: typeof BtnStyleTypes = BtnStyleTypes;

    public wording: ILabels = {
        close: Yii.t('wui-quotation-js', 'Fermer'),
        next: Yii.t('wui-quotation-js', "Passer à l'étape suivante"),
    };

    @Input()
    public items: IBreadcrumbItem[];

    public close(): void {
        this.onClose.emit();
    }

    public next(): void {
        this.onNext.emit();
    }

    public notify(event: string): void {
        this.onNotify.emit(event as EQuotationEntryPoints);
    }
}
